import { Component, Input } from '@angular/core';
import { translate } from '@ngneat/transloco';
import { Category, SeatDetails, humanReadableSeatDetails } from '../../../models';

@Component({
  selector: 'app-seat-details',
  templateUrl: './seat-details.component.html',
  standalone: true,
})
export class SeatDetailsComponent {
  public translate = translate;

  @Input() public seatDetails: SeatDetails;
  @Input() public displayedSeatingInformation: Category['displayedSeatingInformation'];
  public humanReadableSeatDetails = humanReadableSeatDetails;

}
